export const ACTION_CODE = 'DEAL_ABANDONMENT_MOTIVES_ACTIONS';
